function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.818,4.4A20.759,20.759,0,1,0,45.741,22.893,21.228,21.228,0,0,0,38.034,8.8,20.208,20.208,0,0,0,25.021,4.3a16.991,16.991,0,0,0-2.2.1",
  transform: "translate(0.009 -0.012)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.408,19.5l-5-4.1a16.931,16.931,0,0,0-3,10.2l6.406-.7a11.313,11.313,0,0,1,1.6-5.4",
  transform: "translate(0.014 -0.016)",
  fill: "#046eab",
  opacity: 0.4
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.606,16.3l4.1-5a16.988,16.988,0,0,0-10.21-3l.7,6.5a9.083,9.083,0,0,1,5.405,1.5",
  transform: "translate(0.03 -0.013)",
  fill: "#046eab",
  opacity: 0.8
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.81,15l-.7-6.5A15.982,15.982,0,0,0,12.8,13.6l5,4.1a10.272,10.272,0,0,1,5-2.7",
  transform: "translate(0.018 -0.013)",
  fill: "#046eab",
  opacity: 0.6
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.106,27.2,8.6,27.9a16.514,16.514,0,0,0,5.105,9.4l4.1-5a11.471,11.471,0,0,1-2.7-5.1",
  transform: "translate(0.014 -0.021)",
  fill: "#046eab",
  opacity: 0.25
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M49.835,22.37A24.617,24.617,0,0,0,40.526,5.5a21.148,21.148,0,0,0-3.1-2.1l-2,3.794c.8.5,1.6,1,2.4,1.6A20.721,20.721,0,0,1,27.013,45.632a19.7,19.7,0,0,1-10.711-1.8l-2,3.794A25.1,25.1,0,0,0,47.533,35.548a24.02,24.02,0,0,0,2.3-13.179",
  transform: "translate(0.02 -0.049)",
  fill: "#1590cf"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M11.912,41.084A20.713,20.713,0,0,1,35.535,7.2l2-3.8A24.877,24.877,0,0,0,5.606,9.3h0a24.9,24.9,0,0,0,3.6,35.086,26.209,26.209,0,0,0,5.305,3.3l2-3.8a19.541,19.541,0,0,1-4.6-2.8",
  transform: "translate(0.005 -0.01)",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M11.912,41.084A20.713,20.713,0,0,1,35.535,7.2l2-3.8A24.877,24.877,0,0,0,5.606,9.3h0a24.9,24.9,0,0,0,3.6,35.086,26.209,26.209,0,0,0,5.305,3.3l2-3.8a19.541,19.541,0,0,1-4.6-2.8",
  transform: "translate(0.005 -0.01)",
  fill: "#59b4d9"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M36.4,12.6l-4.1,5A10.763,10.763,0,0,1,34.6,21h6.807A17.37,17.37,0,0,0,36.4,12.6Z",
  transform: "translate(0.038 -0.015)",
  fill: "#046eab"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M23.1,27a2.949,2.949,0,0,1,2.1-5,3.233,3.233,0,0,1,2.1.8H42.22a2.1,2.1,0,1,1,0,4.2H27a2.737,2.737,0,0,1-1.9.8,2.178,2.178,0,0,1-2-.8",
  transform: "translate(0.028 -0.019)",
  fill: "#19457a"
});

var SvgMonitor = function SvgMonitor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49.906,
    viewBox: "0 0 50 49.906",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMonitor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/monitor.65748b14.svg";
export { ForwardRef as ReactComponent };